import React, { FC } from 'react';
import { ModalManagementButtons } from '../ModalManagementButtons';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { COMMENT_FORM_FIELD, commentDetailsSchema, commentInitialValues } from '../../constants/comment/comment-form';
import { FormInput } from '../merchants/FormInput';
import { InputType } from '../form/form-input-constants';
import { setNotification } from '../../store/merchnts/actions/application-details';
import { useParams } from 'react-router-dom';
import { useMerchants } from '../../store/merchnts/merchants-context';

export enum NOTIFICATION_TYPES {
  APPLICANT = 'applicant',
  ACCOUNT_MANAGER = 'account_manager',
}

interface Props {
  name: NOTIFICATION_TYPES;
  onClose: () => void;
  onSuccess: () => void;
  onError: () => void;
}

export const NotificationModal : FC<Props> = (props) => {
  const { name, onClose, onSuccess, onError } = props;
  const { t } = useTranslation();
  const { applicationId } = useParams<{ applicationId: string }>();
  const { merchantState: { isRiskRequestLoading }, dispatch } = useMerchants();

  const formik = useFormik({
    initialValues: commentInitialValues,
    validationSchema: commentDetailsSchema,
    onSubmit: async (): Promise<void> => {
      if (!formik.isValid) return;
      const params = {
        comment: formik.values[COMMENT_FORM_FIELD.COMMENT],
      };

      await setNotification({
        dispatch,
        applicationId,
        notificationType: name,
        params,
        onSuccess,
        onError
      });
    },
  });

  return (
    <form className="px-8 pb-8" onSubmit={formik.handleSubmit}>
      <div>
        You are about to send a notification to the
        <span className="fw-bolder ms-1">
          {
            name === NOTIFICATION_TYPES.APPLICANT
              ? 'Applicant'
              : 'Account manager'
          }.
        </span>
      </div>

      <FormInput
        formik={formik}
        key={COMMENT_FORM_FIELD.COMMENT}
        fieldName={COMMENT_FORM_FIELD.COMMENT}
        label="To proceed, please write your comments below:"
        placeholder={t('APPLICATION_DETAILS.LABEL.TEXTAREA_APPROVED_PLACEHOLDER')}
        inputType={InputType.Description}
        isEditMode={true}
        // additionalClasses={additionalClass}
      />

      <ModalManagementButtons
        onCancel={onClose}
        containerAdditionalClasses="mt-10"
        isConfirmBtnLoading={isRiskRequestLoading}
        confirmBtnName="Send"
        confirmBtnAdditionalClasses="w-100px"
      />
    </form>
  );
};
